import React from "react";
import { Quote, Star, UserCircle } from "lucide-react";

export const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Parent Testimonial",
      role: "Parent",
      image: "",
      quote: "YCPS has transformed my children's education. The teachers are dedicated and the Christian values they instill are priceless.",
      rating: 5
    },
    {
      name: "Alumni Testimonial",
      role: "Alumni, Class of 2020",
      image: "",
      quote: "The foundation I received at YCPS prepared me for university success. I'm forever grateful for the quality education.",
      rating: 5
    },
    {
      name: "Parent Testimonial",
      role: "Parent",
      image: "",
      quote: "The school's commitment to both academic excellence and character development is exactly what we wanted for our children.",
      rating: 5
    }
  ];

  return (
    <section className="py-16 bg-[#002147]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#FF6B00]/20 text-[#FF6B00] px-4 py-2 rounded-full mb-4">
            <Quote size={18} />
            <span className="font-semibold text-sm">Testimonials</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            What Our Community Says
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto">
            Hear from parents, students, and alumni about their experiences at Young Christian Preparatory School.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-white/10 hover:bg-white/15 transition-all duration-300"
              data-testid={`testimonial-${index}`}
            >
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#FACC15] text-[#FACC15]" />
                ))}
              </div>
              
              {/* Quote */}
              <p className="text-gray-200 mb-6 italic">
                "{testimonial.quote}"
              </p>
              
              {/* Author */}
              <div className="flex items-center gap-4">
                {testimonial.image ? (
                  <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#FF6B00]" />
                ) : (
                  <div className="w-12 h-12 rounded-full bg-[#FF6B00]/20 border-2 border-[#FF6B00] flex items-center justify-center">
                    <UserCircle size={24} className="text-[#FF6B00]" />
                  </div>
                )}
                <div>
                  <h4 className="text-white font-semibold">{testimonial.name}</h4>
                  <p className="text-gray-400 text-sm">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
